module.exports = __webpack_public_path__ + "media/images/login-background-44df3e05.png";